<template>
     <div id="gb_viewer_chart"  style="width:100%">
        <canvas ref="chartObj"  id="myChart" width="400" height="400"></canvas>
    </div>
</template>
<script>
import Chart from 'chart.js';
import tinycolor from "tinycolor2"

  export default {
     props: ['teams','eventData'],
     mounted: async function () {
         this.loadChart()
         this.display_text_update_events()
     },
     methods: {
          loadChart: async function () {

           
              var options = {
            type: 'line',
            data: {

                datasets: []
            },
            options: {
                onClick: this.chartClickEvent,
                scales: {
                    yAxes: [{

                        scaleLabel: {
                            display: true,
                            labelString: 'Score'
                        },
                        ticks: {
                            padding: 25,
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        type: "time",

                        time: {
                            minUnit: 'second',
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Timeline'
                        }
                    }],
                },
                events: ['mousemove', 'click'], // this is needed, otherwise onHover is not fired
                onHover: (event, chartElement) => {
                    event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    itemSort: function (a, b) {
                        return b.value - a.value;
                    },
                    callbacks: {
                        title: function (tooltipItem) {
                            var title = "event"
                            if (this.com.eventData.events[tooltipItem[0].index].teamID > -1) {

                                title = this.com.eventData.teams[this.com.eventData.events[tooltipItem[0].index].teamID].name || "team " +this.com.eventData.events[tooltipItem[0].index].teamID
                            }
                            return title + ": " + this.com.eventData.events[tooltipItem[0].index].description
                        }.bind({ com: this}),
                        footer: function (tooltipItem) {

                            return tooltipItem[0].label
                        }

                    }
                }

            }
        }
for (let index = 0; index < this.eventData.teams.length; index++) {
    const team = this.eventData.teams[index];
    var color = tinycolor(team.color)

    if (color.isLight()){
        team.color = "#"+color.darken().toHex()
    }

       options.data.datasets.push({
                    label: team.name,
                    borderColor: team.color,
                    backgroundColor: team.color,
                    data: [],
                    steppedLine: true,
                    fill: false,
                    spanGaps: true
                })
}


              var canvas = this.$refs.chartObj
             
             var ctx = canvas.getContext('2d');
              this.chart = new Chart(ctx, options );

          },
             display_text_update_events:  async function() {

        var output = ""
        this.chart.data.datasets.forEach((dataset) => {
            dataset.data = []
            x += 1
        });
        var max = 0
        for (let index = 0; index < this.eventData.events.length; index++) {
            const event = this.eventData.events[index];
          //  let date = new Date(event.time * 1000)
            //var title = "event"
            if (event.teamID > -1) {
           //     var teamColor = this.eventData.teams[event.teamID].color || "rgb(41, 41, 41)"
           //     title = this.eventData.teams[event.teamID].name || "team " + event.teamID
            }
         //   output =
           //     '<div  style="border-left: 2px solid ' + teamColor + ';" class="w-100 d-flex align-items-center p-2 timeline_box"><div class=" timeline_time"> ' + date.toLocaleTimeString() + ' </div> <div class="timeline_text">' + title + ": " + event.description + '<br /><span class="timeline_small">' + this.renderScore(event) + '</span></div><div ' + (this.eventData.isActive ? "style='display:none'" : "") + ' class="timeline_watch" onclick="watchAtEvent(' + index + ')" >Watch</div></div>' + output



            let scores = event.scores
            let time = event.time
            var x = 0

            this.chart.data.datasets.forEach((dataset) => {
                dataset.data.push({ x: time * 1000, y: scores[x] });
                x += 1

                if (max < scores[x]) {
                    max = scores[x]
                }
            });


        }
        console.log("chart max: ", max)
        // this.chart.options.scales.yAxes[0].ticks.max = (max + (max / 3))

        this.chart.update();
        //document.getElementById(this.timeline_feed).innerHTML = output
        return output
    },
     chartClickEvent(event, array) {
        if (array.length > 0) {
            let index = array[0]._index
            console.log(index)
           this.$emit("watchTimeline", index)
        }
    }

     }
  }
</script>